import React, { useEffect, useState } from "react";
import axiosInstance from "../request";
import { URL } from "../api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import getPrivilegeList from "./PrivilegeList";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


  const MandateRegistration = () => {
  const privilegeList = getPrivilegeList();
  const [mandates, setMandates] = useState([]);
  const [customerId, setCustomerId] = useState("");
  const navigate = useNavigate();

  const [showNotifyPopup, setShowNotifyPopup] = useState(false);
  const [notifyCustomerId, setNotifyCustomerId] = useState("");
  const [notifyAmount, setNotifyAmount] = useState("");
  const [loadingNotify, setLoadingNotify] = useState(false);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [hasNextPage, setHasNextPage] = useState(true);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedMandate, setSelectedMandate] = useState(null);
  const [updateAmount, setUpdateAmount] = useState("");
  const [validityEnd, setValidityEnd] = useState("");

  // Company/Branch from localStorage
  const companyCode = localStorage.getItem("companyCode");
  const branchCode = localStorage.getItem("branch_code");


  const fetchMandates = async (page = 0) => {
    try {
      const params = { page, size: rowsPerPage };

      if (customerId) params.customerId = customerId;

      // Add company/branch filter from localStorage
      if (companyCode) params.companyCode = companyCode;
      if (companyCode && branchCode && branchCode !== "null") params.branchCode = branchCode;

      const res = await axiosInstance.get(URL.MANDATE_REGISTRATION_LIST, { params });

      const data = Array.isArray(res.data) ? res.data : [];
      setMandates(data);
      setCurrentPage(page + 1);
      setHasNextPage(data.length === rowsPerPage);

    } catch (error) {
      console.error("Mandate fetch failed", error);
      toast.error("Failed to fetch mandate list");
      setMandates([]);
    }
  };

const updateOrRevokeMandate = async (type, mandate) => {
  try {
    const params = {
      originalMerchantRequestId: mandate.merchantRequestId,
      requestType: type,
    };

    if (type === "UPDATE") {
      params.amount = formatAmountTwoDecimal(updateAmount);
      params.validityEnd = validityEnd;
    }

    await axiosInstance.post(URL.MANDATE_UPDATE_REVOKE, null, { params });

    toast.success(`Mandate ${type} successful`);
    setShowUpdateModal(false);
    fetchMandates(currentPage - 1);

  } catch (err) {
    console.error(err);
    toast.error(`Mandate ${type} failed`);
  }
};

const handleRevoke = (row) => {
  updateOrRevokeMandate("REVOKE", row);
};

const getTimestampPlus25Hours = () => {
  const d = new Date();
  d.setHours(d.getHours() + 25);

  const tzOffsetMin = d.getTimezoneOffset();
  const sign = tzOffsetMin > 0 ? "-" : "+";
  const pad = (n) => String(Math.floor(Math.abs(n))).padStart(2, "0");
  const hours = pad(tzOffsetMin / 60);
  const minutes = pad(tzOffsetMin % 60);

  const iso =
    d.getFullYear() +
    "-" +
    pad(d.getMonth() + 1) +
    "-" +
    pad(d.getDate()) +
    "T" +
    pad(d.getHours()) +
    ":" +
    pad(d.getMinutes()) +
    ":" +
    pad(d.getSeconds());

  return `${iso}${sign}${hours}:${minutes}`;
};

const handleSendNotification = async () => {
  try {
    if (!notifyCustomerId || !notifyAmount) {
      toast.error("Customer ID and Amount required");
      return;
    }

    const mandate = mandates.find(
      (m) => String(m.customerId) === String(notifyCustomerId)
    );

    if (!mandate) {
      toast.error("No mandate found for this Customer ID");
      return;
    }

    const merchantRequestId = mandate.merchantRequestId;
    const amountFormatted = Number(notifyAmount).toFixed(2);
    const mandateExecutionTimestamp = getTimestampPlus25Hours();

    const formData = new URLSearchParams();
    formData.append("merchantRequestId", merchantRequestId);
    formData.append("amount", amountFormatted);
    formData.append("mandateExecutionTimestamp", mandateExecutionTimestamp);

    setLoadingNotify(true);

    await axiosInstance.post(URL.MANDATE_NOTIFICATION, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    toast.success("Notification sent successfully");
    setShowNotifyPopup(false);
    setNotifyCustomerId("");
    setNotifyAmount("");
  } catch (err) {
    console.error(err);
    toast.error("Failed to send notification");
  } finally {
    setLoadingNotify(false);
  }
};


const formatAmountTwoDecimal = (value) => {
  const num = Number(value);
  if (isNaN(num)) return "";
  return (Math.floor(num * 100) / 100).toFixed(2);
};


  useEffect(() => {
    fetchMandates(0);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") fetchMandates(0);
  };

  const handleReset = () => {
  setCustomerId("");
  setTimeout(() => fetchMandates(0), 0);
};

const downloadExcel = async () => {
  try {
    const params = {
      page: 0,
      size: 100000,
    };

    if (customerId) params.customerId = customerId;
    if (companyCode) params.companyCode = companyCode;
    if (companyCode && branchCode && branchCode !== "null") {
      params.branchCode = branchCode;
    }

    const res = await axiosInstance.get(
      URL.MANDATE_REGISTRATION_LIST,
      { params }
    );

    const allMandates = Array.isArray(res.data) ? res.data : [];

    if (allMandates.length === 0) {
      toast.warning("No data available to export");
      return;
    }

    const excelData = allMandates.map((row, index) => ({
      "S.No": index + 1,
      "ID": row.id,
      "Merchant Request ID": row.merchantRequestId,
      "Customer ID": row.customerId,
      "Customer Name": row.customerName || "-",
      "Customer Phone": row.customerPhone || "-",
      "UMN": row.umn || "-",
      "Payer VPA": row.payerVpa || "-",
      "Payer Name": row.payerName || "-",
      "Amount": Number(row.amount).toFixed(2),
      "Mandate Type": row.mandateType,
      "Recurrence Pattern": row.recurrencePattern,
      "Status": row.statusAfterMandate || row.status,
      "Gateway Response": row.gatewayResponseMessage,
      "Mandate Timestamp": row.mandateTimestamp
        ? new Date(row.mandateTimestamp).toLocaleString()
        : "-"
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "UPI_AutoPay_Report"
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(
      fileData,
      `UPI_AutoPay_Report_${new Date()
        .toISOString()
        .split("T")[0]}.xlsx`
    );
  } catch (error) {
    console.error(error);
    toast.error("Failed to export Excel");
  }
};

return (
  <div className="container">
      <h3 className="mb-4">Mandate Registration</h3>

     <div className="card mb-3 p-3">
  <div className="row align-items-end gx-2 gy-2">
    <div className="col-auto">
      <label className="form-label">Customer ID</label>
      <input
        type="number"
        className="form-control form-control-sm"
        value={customerId}
        placeholder="Enter Customer ID"
        onChange={(e) => setCustomerId(e.target.value)}
        onKeyDown={handleKeyDown}
      />
    </div>

    <div className="col-auto">
      <button
        className="btn btn-sm btn-primary mt-1"
        onClick={() => fetchMandates(0)}
      >
        Search
      </button>
    </div>

    <div className="col-auto">
      <button
        className="btn btn-sm btn-secondary mt-1"
        onClick={handleReset}
      >
        Reset
      </button>
    </div>

    <div className="col-auto ms-auto d-flex gap-2">

  <button
    className="btn btn-sm btn-primary mt-1"
    onClick={downloadExcel}
  >
    <i className="bi bi-file-earmark-excel me-1"></i>
    Mandate Registration Excel
  </button>

  {privilegeList.mandateNotificationView && (
    <button
      className="btn btn-sm btn-success mt-1"
      onClick={() => setShowNotifyPopup(true)}
    >
      UPI Auto Pay Notification
    </button>
  )}

</div>
  </div>
</div>


      {/* TABLE */}
      <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
        <table className="table table-sm table-bordered table-hover align-middle">
          <thead className="table-dark text-center">
            <tr>
              <th>S.No.</th>
              <th>ID</th>
              <th>Merchant Request ID</th>
              <th>Customer ID</th>
              <th>Customer Name</th>
              <th>Customer Phone</th>
              <th>UMN</th>
              <th>Payer VPA</th>
              <th>Payer Name</th>
              <th>Amount</th>
              <th>Mandate Type</th>
              <th>Recurrence Pattern</th>
              <th>Status</th>
              <th>Gateway Response Message</th>
              <th>Mandate Timestamp</th>
              <th>Action</th>

            </tr>
          </thead>

          <tbody className="text-center">
{mandates.length > 0 ? (
  mandates.map((row, index) => (
    <tr key={row.id}>
      <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{row.id}</td>
                  <td>{row.merchantRequestId}</td>
                  <td>{row.customerId}</td>
                  <td>{row.customerName || "-"}</td>
                  <td>{row.customerPhone || "-"}</td>
                  <td>{row.umn || "-"}</td>
                  <td>{row.payerVpa || "-"}</td>
                  <td>{row.payerName || "-"}</td>
                  <td>₹{Number(row.amount).toFixed(2)}</td>
                  <td>{row.mandateType}</td>
                  <td>{row.recurrencePattern}</td>
                 <td>
  <span
    className={`badge ${
      (row.statusAfterMandate || row.status) === "SUCCESS"
        ? "bg-success"
        : "bg-danger"
    }`}
  >
    {row.statusAfterMandate || row.status}
  </span>
</td>

                  <td>{row.gatewayResponseMessage}</td>
                  <td>
                    {row.mandateTimestamp
                      ? new Date(row.mandateTimestamp).toLocaleString()
                      : "-"}
                  </td>
                  <td>
  <div className="d-flex gap-1 justify-content-center">
    <button
      className="btn btn-sm btn-primary"
      onClick={() =>
        navigate(`/RecurringPayments?merchantRequestId=${row.merchantRequestId}`)
      }
    >
      View
    </button>

  <button
  className="btn btn-warning btn-sm"
  onClick={() => {
    setSelectedMandate(row);
    setUpdateAmount(formatAmountTwoDecimal(row.amount));
    setValidityEnd(row.validityEnd || "");
    setShowUpdateModal(true);
  }}
>
  Update
</button>



    {privilegeList.mandateRevokeView && (
      <button
        className="btn btn-sm btn-danger"
        onClick={() => handleRevoke(row)}
      >
        Revoke
      </button>
    )}

    <button
      className="btn btn-sm btn-info text-white"
      onClick={() =>
        navigate(`/MandateNotifications?customerId=${row.customerId}`)
      }
      title="View Notifications"
    >
      <i className="bi bi-bell-fill me-1"></i>Notify
    </button>
  </div>
</td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="16" className="text-muted text-center">
                  No mandate records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

   <div className="d-flex justify-content-center mt-3">
  <div className="d-flex gap-1">
    <button
      className="btn btn-sm btn-outline-primary"
      disabled={currentPage === 1}
      onClick={() => fetchMandates(currentPage - 2)}
    >
      Prev
    </button>

    <span className="align-self-center px-2">Page {currentPage}</span>

    <button
      className="btn btn-sm btn-outline-primary"
      disabled={!hasNextPage}
      onClick={() => fetchMandates(currentPage)}
    >
      Next
    </button>
  </div>
  {showUpdateModal && (
  <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-sm">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Update Mandate</h5>
          <button className="btn-close" onClick={() => setShowUpdateModal(false)} />
        </div>

        <div className="modal-body">
          <div className="mb-2">
            <label className="form-label">Amount</label>
            <input
            type="text"
            step="0.01"
            className="form-control"
            value={updateAmount}
            onChange={(e) => setUpdateAmount(e.target.value)}
           onBlur={() => {
              if (updateAmount !== "") {
                setUpdateAmount(formatAmountTwoDecimal(updateAmount));
              }
            }}
          />

          </div>

          <div className="mb-2">
            <label className="form-label">Validity End</label>
            <input
              type="date"
              className="form-control"
              value={validityEnd}
              onChange={(e) => setValidityEnd(e.target.value)}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => setShowUpdateModal(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-success btn-sm"
            onClick={() => updateOrRevokeMandate("UPDATE")}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
)}
</div>
{showNotifyPopup && (
  <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-sm">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Send UPI AutoPay Notification</h5>
          <button
            className="btn-close"
            onClick={() => setShowNotifyPopup(false)}
          />
        </div>

        <div className="modal-body">
          <div className="mb-2">
            <label className="form-label">Customer ID</label>
            <input
              type="text"
              className="form-control"
              value={notifyCustomerId}
              onChange={(e) => setNotifyCustomerId(e.target.value)}
            />
          </div>

          <div className="mb-2">
            <label className="form-label">Amount</label>
            <input
              type="number"
              step="0.01"
              className="form-control"
              value={notifyAmount}
              onChange={(e) => setNotifyAmount(e.target.value)}
              onBlur={() => {
                if (notifyAmount !== "") {
                  setNotifyAmount(formatAmountTwoDecimal(notifyAmount));
                }
              }}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => setShowNotifyPopup(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-success btn-sm"
            disabled={loadingNotify}
            onClick={handleSendNotification}
          >
            {loadingNotify ? "Sending..." : "Send"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

      <ToastContainer />
    </div>
  );
};

export default MandateRegistration;
